import { Box, Flex } from "@chakra-ui/react";
import { useState } from "react";

const SlidingToggle = ({ onToggle, toggle = true, identifier }) => {
  const [isOn, setIsOn] = useState(toggle);

  const toggleSwitch = () => {
    const newState = !isOn;
    setIsOn(newState);
    onToggle?.({ status: newState, id: identifier });
  };

  return (
    <Flex align="center" px="4px">
      <Box
        as="button"
        type="button"
        role="switch"
        aria-checked={isOn}
        w="36px"
        h="20px"
        bg={isOn ? "green.500" : "gray.300"}
        borderRadius="full"
        p="2px"
        cursor="pointer"
        transition="background-color 0.2s ease"
        _focusVisible={{ outline: "2px solid", outlineColor: "green.300", outlineOffset: "2px" }}
        onClick={toggleSwitch}
      >
        <Box
          w="16px"
          h="16px"
          bg="white"
          borderRadius="full"
          transform={isOn ? "translateX(16px)" : "translateX(0)"}
          transition="transform 0.2s ease"
          boxShadow="0 1px 2px rgba(16,24,40,0.2)"
        />
      </Box>
    </Flex>
  );
};

export default SlidingToggle;
